import { imageFromUuid } from "../../helpers/utility";
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { BtnComponent } from "../button";
import ShareOptions from "../../pages/share";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useMemo, useState } from "react";
import { CheckBox } from "../reactHookFormFields/checkbox";
import { useForm } from "react-hook-form";
import useSendPdfToChat from "../../hooks/useSendPdfToChat";

export const PdfViewer = ({data, uuid, closeHandler, isShowLinkToPatientChartWithImage=false }) => {
  const {sendPdfToChat, isSending} = useSendPdfToChat();

  const {control} = useForm();
  let url = imageFromUuid(uuid);
  const [isOpenShareEfax, setIsOpenShareEfax] = useState(false);
  const groupChatContext = useGroupChatContext();
  const {authData} = useMemo(() => ({
    authData: groupChatContext.authData,
  }));
  
  const openInNewTab = () => {
    window.open(url, "_blank");
  };

  const shareViaEfax = () => { 
    setIsOpenShareEfax(true);
  };

  const handleLinkToPatientChart = async (e) => {
    if (data?.files?.length > 0) {
      let sendingFiles = data?.files.map(file => ({ ...file }));
      sendingFiles[0].is_link_to_patient_chart = e.target.checked;
      await sendPdfToChat(sendingFiles);
      closeHandler();
    }
  }

  return (
    <>
      <PageDialogContent>
        <iframe
          id="viewPdfFrame"
          width="100%"
          height="100%"
          frameBorder="1"
          allow="autoplay"
          src={url}
        ></iframe>
      </PageDialogContent>
      <PageDialogFooter>
        <BtnComponent text="Close" btnType="default" onClick={closeHandler} />
        <BtnComponent text="Open in New Tab" onClick={openInNewTab} />
        {isShowLinkToPatientChartWithImage && !data?.files[0]?.is_link_to_patient_chart && <CheckBox disabled={isSending} control={control} name="linkToPatientChart" title="Link to Patient Chart"  onChange={handleLinkToPatientChart}/>}
        {(data?.event_type == 'create_task' && authData?.is_provider) ?
          <>
            <BtnComponent onClick={shareViaEfax} text="Share via Efax" />
            <BtnComponent onClick={() => {}} text="Mark as completed & Assign Back" />
            <BtnComponent onClick={() => {}} text="Mark as completed" />
            <BtnComponent onClick={() => {}} text="Assign Back Task" />
          </>
        : null}
      </PageDialogFooter>

      {isOpenShareEfax ?
        <ShareOptions
          bulk={true}
          sharePreviewUrl={"messages/read_attachment?uuid"}
          printData={"printData"}
          setShowShareeFax={setIsOpenShareEfax}
          // userUniqueId={selectedFiles}
        />
        :
        null
      }
    </>
  );
};